(function dynamicDateDirectiveDefinition() {
    'use strict';

    angular.module('CustomControlDate', ['DateTimePicker'])
        .directive('dynamicDate', function () {
            return {
                replace: true,
                restrict: 'E',
                link: function (scope, iElement, iAttrs) {
                },
                templateUrl: '/app/directives/custom-control-date/custom-control-date-template.html'
            };
        });

    angular.module('CustomControlDate')
       .directive('dynamicFilterDate', function () {
           return {
               replace: true,
               require: '^form',
               restrict: 'E',
               controller: [
                       '$scope', function ($scope) {
                           if ($scope.data) {
                               $scope.data.metadataSearchTypeFrom = 'GreaterThanOrEqual';
                               $scope.data.metadataSearchTypeTo = 'LessThanOrEqual';
                           }
                           $scope.data.nullValue = false;
                       }],

               link: function (scope, iElement, iAttrs,formCtrl) {
                   scope.metadataSearchTypeFrom = 'GreaterThanOrEqual';
                   scope.metadataSearchTypeTo = 'LessThanOrEqual';
                   scope.formCtrl = formCtrl;
                   scope.filterNullValue = iAttrs.filternullvalue;
               },
               templateUrl: '/app/directives/custom-control-date/custom-control-filter-date-template.html'
           };
       });
})();